import React, { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

import { ticketUserIdSelector } from '@/redux/app/selectors/ticket';
import { inboxUsersSelector } from '@/redux/app/selectors/inbox';
import { setTicketOwner } from '@/redux/app/actions/ticket';
import { NavigationPaneRouteParamsContext } from '@/lib/navigation';

export interface TicketOwnerSelectorProps {
  ticket: string;
}

export const TicketOwnerSelector = ({ ticket }: TicketOwnerSelectorProps) => {
  const { subdomain } = useContext(NavigationPaneRouteParamsContext);
  const ownerId = useSelector(_.partial(ticketUserIdSelector, ticket)) || '';
  const users = useSelector(_.partial(inboxUsersSelector, subdomain)) || {};

  const dispatch = useDispatch();
  const handleChange = useCallback((event) => {
    const [{ value }] = event.target.selectedOptions;
    dispatch(setTicketOwner(subdomain, ticket, value));
  }, [subdomain, ticket, dispatch]);

  interface User {
    id: string,
    name: string,
    available: boolean,
    email: string,
  }

  const sortedUsers = Object.values(users).sort((a: User, b: User) => {
    if (a.available === b.available) {
      return a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1;
    }
    return a.available ? -1 : 1;
  });

  const allUsers = sortedUsers.map(
    (user: User) =>
      <option key={user.id} value={user.id}>{`${user.name} ${user.available ? '✅ ' : '⚪️'}`}</option>,
  );

  return (
    <form data-status={ownerId} className={`ticket-owner-form owner-form-${ticket} noselect`}>
      <select
        value={ownerId}
        className="status-changer"
        id={`status-${ticket}`}
        data-id={ticket}
        data-role="none"
        onChange={handleChange}
        autoComplete="off"
      >
        <option key="unassigned" value="">Unassigned</option>
        {allUsers}
      </select>
    </form>
  );
};
